import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import { withAsyncActions } from 'react-async-client';
import { NavLink } from 'react-router-dom';

import { scenario } from 'constants/routes';

import { fullAutoOptions } from 'constants/asyncClient';
import { getCoursesList, getUser } from 'actions/asyncActions';
import { SidebarLink } from 'components/common/tableComponents/cellTemplates';
import { SCENARIO_SIDEBAR } from 'constants/sidebarTypes'

@connect(state => ({ user: getUser.selectData(state) }))
@withAsyncActions({
    getList: getCoursesList
        .withPayload(props => ({
            user: props.user.id
        }))
}, fullAutoOptions)
export default class CoursesListTable extends Component {
    static propTypes = {
        getList: PropTypes.object.isRequired,
        renderTable: PropTypes.func.isRequired,
    }

    tableColumns = [
        {
            name: 'sidebarCourseLink',
            width: 50,
            additionalClass: 'p-l-15',
            template: ({ item }) => {
                const id = path(['testInfo', 'id'], item);
                const name = path(['testInfo', 'name'], item);

                return (
                    <SidebarLink
                        componentName={SCENARIO_SIDEBAR}
                        item={{ id, name }}
                        icon="case"
                        value={name} />
                );
            },
        },
        {
            name: 'number',
            width: 45,
            template: ({ rowIndex }) => rowIndex + 1,
        },
        {
            name: 'test',
            dataIndex: 'testInfo',
            label: <Translate content="education.courses.headers.name" />,
            template: ({ item }) => {
                const id = path(['testInfo', 'id'], item);
                const name = path(['testInfo', 'name'], item);

                return (
                    <NavLink to={scenario.stringify({ id })}>
                        {name}
                    </NavLink>
                );
            },
        },
        {
            name: 'states',
            label: <Translate content="education.scenario.stages" />,
            template: ({ item: { testInfo = {} } }) => (
                <Translate content={`education.scenario.state.${testInfo.state}`} />
            ),
            width: 550
        },
    ];

    render() {
        const { getList, renderTable: Table } = this.props;

        return (
            <Table {...getList} columns={this.tableColumns} />
        );
    }
}
